var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TimePicker',{attrs:{"format":"HH:mm","size":_vm.size,"value":_vm.currentTime,"type":"time","placeholder":_vm.L('SelectDate')},on:{"on-change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }